import mirror from 'keymirror';
import MenuItems from '../lib/menu-items';

export const actionTypes = mirror({
  MENU_ITEMS_GET_ERROR: null,
  MENU_ITEMS_GET_IN_PROGRESS: null,
  MENU_ITEMS_GET_SUCCESS: null,
});

const menuItemsGetError = error => ({
  type: actionTypes.MENU_ITEMS_GET_ERROR,
  error,
});

const menuItemsGetInProgress = () => ({
  type: actionTypes.MENU_ITEMS_GET_IN_PROGRESS,
});

const menuItemsGetSuccess = list => ({
  type: actionTypes.MENU_ITEMS_GET_SUCCESS,
  list,
});

export const getMenuItems = () => async (dispatch, getState) => {
  const state = getState();
  if (state.layout.menuItems.length === 0) {
    try {
      dispatch(menuItemsGetInProgress());
      const items = await MenuItems.get();
      dispatch(menuItemsGetSuccess(items));
    } catch (err) {
      dispatch(menuItemsGetError(err));
    }
  }
};
